// Orders/TabContent/OrderHistory.js
import React from "react";

const OrderHistory = () => {
  return (
    <div className="p-6">
      <h3 className="text-lg font-bold">Order History</h3>
      <p className="text-gray-600">
        Previous orders and status updates will be displayed here.
      </p>
    </div>
  );
};

export default OrderHistory;
